// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"d1365f42","453":"c40833ab","667":"7ceedb4c","821":"6e43b7ee"}[chunkId] + ".chunk.js";
};